export default __webpack_public_path__ + "2bbca65fd8656c1add1da36aa10e54ca.png";